import React, { Component } from "react";
import { Form, Popup } from "semantic-ui-react";

import { withRouter } from "react-router";

import * as searchFieldStore from "../../../services/searchField";

const options = [
  {
    text: 'Par nom',
    value: 'name'
  },
  {
    text: 'Par affectation',
    value: 'affectation'
  },
  {
    text: 'Par description',
    value: 'description'
  }
];

class SearchInput extends Component {
  state = {
    searchField: searchFieldStore.getSearchField(),
    termSearch: [
      '',
      ''
    ],
    results: []
  };

  onChangeFirstField = event => { 
    this.setState({ termSearch: [
      event.target.value,
      this.state.termSearch[1]
    ]});
  };

  onChangeSecondField = event => {
    this.setState({ termSearch: [
      this.state.termSearch[0],
      event.target.value
    ]});
  };

  onChangeSearchField = (event, { value }) => {
    this.setState({
      searchField: value,
      termSearch: [
        '',
        ''
      ]
    });

    // store new search field
    searchFieldStore.setSearchField(value);
  }

  handleSubmit = event => {
    console.log("In handleSubmit");
    event.preventDefault(); 
    if (this.state.termSearch[0] || this.state.termSearch[1]) {
      if (this.state.searchField === 'name') {
        this.props.history.push(`/search/${this.state.termSearch[0]}:${this.state.termSearch[1]}`);
      }
      else {
        this.props.history.push(`/${this.state.searchField}/${this.state.termSearch[0]}`);
      }
    }
  };

  render() {
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
	      <Form.Group className="custom-form-group" widths="equal">
          {(() => {
            switch(this.state.searchField) {
              case 'name':
                return (
                  <React.Fragment>
                  <Form.Input
                    type="text"
                    placeholder="Prénom"
                    onChange={this.onChangeFirstField}
                  />
                  <Form.Input
                    type="text"
                    placeholder="Nom" 
                    onChange={this.onChangeSecondField}
                  />
                  </React.Fragment>);
              case 'affectation':
                return (
                  <Form.Input
                    type="text"
                    placeholder="Affectation"
                    onChange={this.onChangeFirstField}
                  />);
              case 'description':
                return (
                  <Form.Input
                    type="text"
                    placeholder="Description"
                    onChange={this.onChangeFirstField}
                  />);
              default:
                return (
                  <React.Fragment>
                  <Form.Input
                    type="text"
                    placeholder="Prénom"
                    onChange={this.onChangeFirstField}
                  />
                  <Form.Input
                    type="text"
                    placeholder="Nom" 
                    onChange={this.onChangeSecondField}
                  />
                  </React.Fragment>);
            }
          })()}
          <Form.Select
            options={options}
            defaultValue={this.state.searchField}
            onChange={this.onChangeSearchField}
          />
	        <Form.Button icon="search" />
	      </Form.Group>
        </Form>
      </div>
    );
  }
}

export default withRouter(SearchInput);



// WEBPACK FOOTER //
// ./src/components/NavBar/components/SearchInput.js